import { motion } from "framer-motion";
import { CLIENTS } from "@/lib/content";

const ClientMark = ({ name }) => (
    <div className="flex items-center gap-3 px-10 py-4 opacity-70 hover:opacity-100 transition-opacity duration-300">
        <span className="h-2.5 w-2.5 rounded-full gradient-bg shrink-0" />
        <span className="font-display font-bold text-xl text-slate-500 whitespace-nowrap">{name}</span>
    </div>
);

export const Marquee = () => {
    const row = [...CLIENTS, ...CLIENTS];
    return (
        <section className="border-y border-slate-200/70 bg-white/60 backdrop-blur py-6 overflow-hidden" aria-label="Client brands">
            <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
                className="marquee-track"
                data-testid="client-marquee"
            >
                {[0, 1].map((half) => (
                    <div key={half} className="flex shrink-0" aria-hidden={half === 1}>
                        {row.map((client, i) => (
                            <ClientMark key={`${half}-${i}`} name={client} />
                        ))}
                    </div>
                ))}
            </motion.div>
        </section>
    );
};
